import { render, staticRenderFns } from "./AmTable.vue?vue&type=template&id=64fd0268&"
import script from "./AmTable.vue?vue&type=script&lang=js&"
export * from "./AmTable.vue?vue&type=script&lang=js&"
import style0 from "./AmTable.vue?vue&type=style&index=0&id=64fd0268&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports